import { HTMLAttributes, JSX } from 'react'
import { cn } from '@/utilities/ui'
import { Button } from '@/components/ui/button'
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'
import { i18n } from './i18n'
import { Locale } from '@/providers/Locale/types'

interface Props extends HTMLAttributes<HTMLButtonElement> {
    locale: Locale
    variant: 'start' | 'next' | 'previous'
}

export function EmbeddedButton({ variant, locale, className, ...rest }: Props): JSX.Element {
    return (
        <Button
            className={cn(
                'max-lg:hidden p-8 rounded-none uppercase bg-black inline-flex flex-nowrap text-white cursor-pointer transition-opacity duration-200 group-hover:opacity-100 dark:hover:bg-black dark:hover:border-white dark:hover:border',
                className,
            )}
            {...rest}
        >
            {variant === 'start' && (
                <>
                    {i18n[locale].startSlide} <IconArrowRight className='ml-7' />
                </>
            )}
            {variant === 'previous' && (
                <>
                    <IconArrowLeft className='mr-7' /> {i18n[locale].previousSlide}
                </>
            )}
            {variant === 'next' && (
                <>
                    {i18n[locale].nextSlide} <IconArrowRight className='ml-7' />
                </>
            )}
        </Button>
    )
}
